<template>
  <div class="w100 pt20 pb20 pl20 pr20 bg-w" v-loading="loading">
    <p class="w100 bold mb20 font-18 tx-c">各服务办结率排名</p>

    <div class="w100 flex-box al-c sift-view">
      <DateComp ref="date" :loading="loading" @change="fetchList" />
      <div class="ml10">
        <el-button type="primary" size="mini" @click="fetchList">查询</el-button>
      </div>
    </div>

    <div class="w100 mt20 po-r serve-count-table">
      <p class="w100 mt20 mb20 tx-c grey" v-show="list.length == 0">暂无数据</p>

      <div class="w100 mt20">
        <el-row class="mt20">
          <el-col class="mb20" :span="20" :offset="2" v-for="(item, index) in list" :key="index" v-show="showAll ? true : index < 5">
            <p class="font-14 pb5">
              <span>{{ index + 1 == list.length ? '' : index + 1 + '、' }}{{ item.label }}</span>
              <span class="grey fr">发起量{{ item.total }}，已完结{{ item.value }}</span>
            </p>
            <el-progress :text-inside="true" :stroke-width="18" :percentage="item.proporty" :color="item.label == '总量' ? '#ffb505' : '#367fde'"></el-progress>
          </el-col>
          <el-col class="tx-c" :span="20" :offset="2" v-if="queryRang == 1">
            <el-button style="width: 100px" type="primary" plain size="mini" round @click="showAll = !showAll">{{ showAll ? '收 起' : '显示更多' }}</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import DateComp from "@/components/ServeCount/DateComp";

export default {
  name: "ServeCountForHandle",
  components: {
    DateComp
  },
  props: ["queryRang"],
  data() {
    return {
      loading: false,

      list: [],
      showAll: this.queryRang == 1 ? false : true
    };
  },
  created() {},
  computed: {},
  mounted() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      this.loading = true;

      const date = this.$refs.date.getValue();
      this.$http
        .post(
          "serveStatistics/countServeNum",
          this.$qs.stringify({
            startTime: date[0],
            endTime: date[1],
            queryRang: this.queryRang
          })
        )
        .then(({ data }) => {
          if (data.resStatus == 0 && data.resCode == 0) {
            // console.log(data.resData);
            let arr = [];
            for (const i in data.resData) {
              let obj = {
                value: data.resData[i].finishNum,
                total: data.resData[i].initNum,
                label: data.resData[i].serveName,
                proporty: (data.resData[i].proporty * 100).toFixed(2) * 1
              };
              if (i == data.resData.length - 1) {
                obj.label = "总量";
                obj.proporty = obj.total
                  ? ((obj.value / obj.total) * 100).toFixed(2) * 1
                  : 0;
              }
              arr.push(obj);
            }
            this.list = arr;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "操作失败，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
</style>
